export const WEB_ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    CAPTURE: '/capture',
    SEARCH: '/search',
    CATEGORIES: '/categories',
    BIN: '/bin',
    MORE: '/more',
    NOTE: (id: string) => `/notes/${id}` as const,
} as const;

